var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_9974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4435 9.16757V14.1676C13.4435 14.5212 13.303 14.8603 13.0529 15.1104C12.8029 15.3604 12.4637 15.5009 12.1101 15.5009H2.77678C2.42316 15.5009 2.08402 15.3604 1.83398 15.1104C1.58393 14.8603 1.44345 14.5212 1.44345 14.1676L1.44345 4.83423C1.44345 4.48061 1.58393 4.14147 1.83398 3.89142C2.08402 3.64138 2.42316 3.5009 2.77678 3.5009H7.77678",
    stroke: "#0972D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1101 1.5009L8.44345 8.16757",
    stroke: "#0972D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.11044 1.5009H15.1104V7.5009",
    stroke: "#0972D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_9974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.443451 16.5009)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkBlue);
export default __webpack_public_path__ + "static/media/Icon_Link_Blue.317f558226d91ae226a971a4adf07f35.svg";
export { ForwardRef as ReactComponent };